document.addEventListener('DOMContentLoaded', function(e) {
    let servicesList = document.querySelector('.service_list');
    if (servicesList) {
        let options = {
            root: document.querySelector('#scrollArea'),
            rootMargin: '-40% 0% -60% 0%',
            threshold: 0
        }
        let observer = new IntersectionObserver(highlightService, options);

        function highlightService(entries) {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    let currActive = servicesList.querySelector('.active');
                    if (currActive) {
                        currActive.classList.remove('active');
                    }
                    entry.target.classList.add('active');
                }
            })
        }

        let services = servicesList.querySelectorAll('li');
        services.forEach(service => {
            observer.observe(service);
        })
    }
})